import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Hidden from "@material-ui/core/Hidden";
import Tabs from "@material-ui/core/Tabs";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import { Trad } from "../../components/";
import ChiamaWeb, { CChiamaWebParametri } from "../../ChiamaWeb";
import { _MainNavItem } from "./MainNavItem";
import { _MainNavMobile } from "./MainNavMobile";

export const _MainNav: React.FC<Glob.IGlobaleProps> = props => {
    const [IsLoading, setIsLoading] = useState(true);
    const [Menu, setMenu] = useState<Dati.CRisAPIListaMenu | undefined>(undefined);

    const renderMainNav = () =>
        Menu == undefined || Menu.Dati == undefined ? (
            <span>{Trad.Trad("Errore")}</span>
        ) : (
            <>
                <Hidden mdUp>
                    <_MainNavMobile Data={Menu.Dati} />
                </Hidden>
                <Hidden smDown>
                    <Tabs value={0} variant="scrollable">
                        {Menu.Dati.map(item => (
                            <_MainNavItem Data={item} key={item.ID_Menu} />
                        ))}
                    </Tabs>
                </Hidden>
            </>
        );

    const loadData = () => {
        const menu = props.Globale[Glob.TTipiGlobale.Menu];
        const Param: CChiamaWebParametri = {
            URL: `/api/Menu/Main?sessione=${Glob.GetSessione().Sessione}&main=${menu.Main}`,
            OnRis: (sender: ChiamaWeb, data: Dati.CRisAPIListaMenu) => {
                setIsLoading(false);
                setMenu(data);
            }
        };

        Glob.Log(Glob.LogCat.Menu, false, "AggiornaMenu Main", menu.Main);
        new ChiamaWeb().Chiama(Param);
    };

    useEffect(loadData, [props.Globale[Glob.TTipiGlobale.Menu]]);

    return IsLoading ? (
        <p>
            <em>{Trad.Trad("Caricamento...")}</em>
        </p>
    ) : (
        renderMainNav()
    );
};



// WEBPACK FOOTER //
// ./src/inar2/layout/MainNav.tsx